import { render } from "./ModalFormUser.vue?vue&type=template&id=752ec5f0"
import script from "./ModalFormUser.vue?vue&type=script&lang=js"
export * from "./ModalFormUser.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__